module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"addFtpConnection_Header":"Nuova connessione","editFtpConnectionDialog_Header":"Modifica impostazioni","formAddEditFtpConnection":{"Name":"Nome Connessione","Url":"Url","Username":"Nome utente","Password":"Password"}}}')
  delete Component.options._Ctor
}
